export const ROUTES = {
    password: '/',
    driverRegistration: '/driver-registration',
    organizationAdmin: '/organization-admin',
    acceptDriverRegistration: '/:driverRegistrationId/accept/:organizationId',
    declineDriverRegistration: '/:driverRegistrationId/decline/:organizationId',
} as const;
